<script>

export default {
    
    mounted: function () {
        this.setTitle();
    },

    methods: {

        setTitle: function(title) {

            if ( !title ) {
                let titleOpt = this.$options.title
                title = ( typeof titleOpt === 'function' ) ? titleOpt(this) : titleOpt
            }

            if ( title ) {
                this.$root.$emit('title', title)
            }
        }
    }
}

</script>
 